<script setup>
import { onMounted } from 'vue';
import { object, string } from 'yup'
import { Form } from 'vee-validate';
import { ContactPageSchema } from '~/schemas/ContactPage';

useHead({
  title: 'تماس با ما | ارتباط مستقیم با کارشناسان نواتل',
  meta: [
    {
      name: 'description',
      content: 'برای دریافت مشاوره رایگان در زمینه خدمات ابری و ارتباط با تیم پشتیبانی نواتل، از طریق فرم تماس یا شماره‌های درج‌شده اقدام نمایید. پشتیبانی نواتل 24/7 در دسترس شماست.'
    }
  ],
  link: [
    {
      rel: 'canonical',
      href: "https://navatel.ir/contact-us/"
    }
  ],
  script: [
    {
      type: 'application/ld+json',
      textContent: JSON.stringify(ContactPageSchema)
    },
  ],
})

const {validateFaChar ,validateMobile , validateEmail}  = useInputHelpers();
const map = ref("")
const topCardDetails = {
  title: "تماس با ما",
  desc: 'نواتل با استفاده از تجربه‌ی ۲۰ ساله شرکت آریا سامانه در امر مشتری‌مداری، وظیفه خود می‌داند تا با پشتیبانی ۲۴ ساعته به نیازها و نگرانی‌های مشترکین در سریع‌ترین زمان پاسخ دهد. برای تماس با نواتل می‌توانید از روش‌هایی که در ادامه برای شما ذکر شده، استفاده کنید. ما در هر لحظه و در هر مکانی آماده دریافت پیغام شما هستیم.',
  img: "/img/contactus.webp",
}
const options = [
  { value: 0, text: 'قصد برقراری ارتباط با کدام واحد را دارید؟', isSelected: true },
  { value: 1, text: 'فروش' },
  { value: 2, text: 'پشتیبانی' },
  { value: 3, text: 'روابط عمومی' },
  { value: 4, text: 'مدیریت' },
]

const { post, loading } = useSendMail()

const isSuccessModalShowState = useState('isSuccessModalShowState')

const initialValues = {
  name: '',
  number: '',
  email: '',
  text: '',
  unit: 0
}
const schema = object({
  name: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  number: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateMobile),
  email: string().test("", "مقدار وارد شده معتبر نیست.", validateEmail),
  text: string().required('این فیلد نباید خالی باشد.'),
  unit: string().required("این فیلد نباید خالی باشد.").test(
    '',
    "این فیلد نباید خالی باشد.",
    function (item) {
      return item != 0
    }
  ),
})
const handleSubmit = async (form, { resetForm }) => {
  if (!loading.value) {
    const { data, error } = await post({
      body: { model: form }
    })

    if (!error.value && data.value === 'ok') {
      resetForm()
      isSuccessModalShowState.value= true
    }
  }
}


onMounted(() => {
  map.value =
    "https://www.openstreetmap.org/export/embed.html?bbox=51.43068194389344%2C35.7040948284963%2C51.43890023231507%2C35.709269745083766&amp;layer=mapnik&amp;marker=35.70668232878254%2C51.43479108810425";

});
</script>

<template>
  <div>
    <BaseTopCard :details="topCardDetails" isWhiteBg />
    <!-- قسمت با ما در ارتباط باشید -->
    <section class="gridClass my-10">
      <h2 class="pb-4">با ما در ارتباط باشید.</h2>
      <div class="flex flex-col w-full items-center">
        <div class="p-10 bg-blue-450/5 w-full">
          <Form
            class="w-full"
            :validation-schema="schema"
            :initial-values="initialValues"
            @submit="handleSubmit"
          >
            <div
              class="flex items-center justify-between [&>*]:w-full lg:[&>*]:w-[48%]  flex-wrap"
            >
              <BaseInput name="name" placeholder="نام و نام خانوادگی" />
              <BaseInput name="number" placeholder="شماره موبایل" isNumber />
              <BaseInput name="email" placeholder="ایمیل (اختیاری) " />
              <BaseInputSelect name="unit" :options="options" />
            </div>
            <BaseInputTextarea name="text" placeholder="متن پیام" />
            <div class="flex justify-end">
              <BaseButton
                class="w-1/2"
                isLean
                size="full"
                color="primary"
                text="ارسال درخواست"
              />
            </div>
          </Form>
        </div>
      </div>
    </section>
    <!-- نقشه و آدرس -->
    <section class="gridClass my-16">
      <div
        class="flex flex-col-reverse lg:flex-row justify-center items-center"
      >
        <div>
          <iframe
            class="desktop-only rounded-xl"
            width="500"
            height="400"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            :src="map"
          />
          <iframe
            class="mobile-only rounded-xl"
            width="250"
            height="200"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            :src="map"
          />
        </div>
        <div class="flex-grow flex flex-col py-6 ps-10">
          <div class="mb-2 text-body1-bold">آدرس شرکت</div>
          <div class="flex-grow flex flex-col justify-between text-body2">
            <div>
              تهران؛ خیابان شریعتی، سه راه طالقانی، ابتدای خیابان خواجه نصیر الدین
              طوسی، پلاک ۲۴۷
            </div>
            <div>تلفن دفتر مرکزی : 82800000-021</div>
            <div>تلفن پشتیبانی 24 ساعته : 82800000-021</div>
            <div>فکس : 82800000-021 داخلی 6</div>
            <div>ایمیل : office@sgas.ir</div>
            <div class="mb-6">کد پستی : 1611613611</div>
            <div class="mb-2 text-body1-bold">اطلاعات حساب</div>
            <div class="mb-1 font-semibold">بانک ملت (به نام شبکه گستران آریا سامانه)</div>
            <div>شماره کارت : <span dir="ltr">6104-3386-4621-9036</span></div>
            <div>شماره حساب : <span dir="ltr">9865699706</span></div>
            <div class="mb-3">شماره شبا : <span dir="ltr">IR610120020000009865699706</span></div>
            <div class="mb-1 font-semibold">بانک اقتصاد نوین (به نام شبکه گستران آریا سامانه)</div>
            <div>شماره کارت : <span dir="ltr">6274-1270-0004-0052</span></div>
            <div>شماره حساب : <span dir="ltr">207-445-81646464-1</span></div>
            <div>شماره شبا : <span dir="ltr">IR630550020744581646464001</span></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
